import React, { Component } from 'react';
import Switch from "react-switch";
import { toast } from 'react-toastify';
import { Popover, OverlayTrigger, Row, Col, Table } from "react-bootstrap";
import DatePicker from 'react-date-picker';

import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';
import CartaEgreso from '../../../components/Reportes/CartaEgreso';
import CargaHoraria from '../../../components/Reportes/CargaHoraria';
import Pensum from '../../../components/Reportes/Pensum';
import ModEstudioSimple from '../../../components/Reportes/ModEstudioSimple';
import ModEstudioCert from '../../../components/Reportes/ModEstudioCert';
import CulminacionEstS from '../../../components/Reportes/CulminacionEstS';
import CulminacionEstCertS from '../../../components/Reportes/CulminacionEstCertS';
import ConsConductaCert from '../../../components/Reportes/ConsConductaCert';

import { ConsultCarrera, NoAceptarSol, AceptarSol } from "../../../funciones/ConstanciaFunction"
let fecha = new Date();

class SolPendientes extends Component {
    state = {
        preloadCarrera: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando"
        },
        openCancel: false,
        openOk: false,
        openReporte: false,
        modalBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        check: true,
        dataRep: "",
        datosEst: "",
        qr: "",
        text1: "",
        text2: "",
        text3: "",
        textFecha: fecha,
        large: "medium"
    }

    constructor (props) {
        super (props);
        ConsultCarrera (props.datos.id_est, (resp) =>{
            this.setState({
                preloadCarrera: {
                    icon: "",
                    text: resp.carrera_name
                },
            })
        })
    }

    openModal = (modal, cancel1) => () => {
        switch(this.props.tipo){
            case "Constancia de Culminación de Estudios (Simple)":
                this.setState ({
                    [modal]: true,
                    [cancel1]: false,
                    openReporte: false,
                    large: "large"
                })
            break;
            case "Constancia de Culminación de Estudios (Certificada)":
                this.setState ({
                    [modal]: true,
                    [cancel1]: false,
                    openReporte: false,
                    large: "large"
                })
            break;
            default:
                this.setState ({
                    [modal]: true,
                    [cancel1]: false,
                    openReporte: false,
                    large: "medium"
                })
            break;
        } 
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    cambiaFecha = (date) => {
        this.setState({ textFecha: date });
    }

    modalCancel = () => {
        const { openCancel, modalBtn1 } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas realmente <strong className="text-danger">Cancelar</strong> esta solicitud de {this.props.tipo}?</div>
                <div style={{fontSize: 11}}>Se le enviará un Email de notificación al estudiante</div>
            </React.Fragment>
        )

        let noAceptar = (id) => () => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                NoAceptarSol (id, this.props.tipo, () => {
                    this.setState({
                        openCancel: false,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                    }, () => {
                        this.props.updateList();
                        toast.info("Has cancelado correctamente la solicitud",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openCancel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(this.props.datos.id)}
            />
        );
    }
    
    modalOk = () => {
        const { openOk, modalBtn1, check, text1, text2, text3, textFecha, large } = this.state;

        let AceptOk = (id) => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Generando el Formato"
                }
            }, () => {              
                AceptarSol (id, check, this.props.tipo, (resp) => {
                    this.setState({
                        check: true,
                        openOk: false,
                        openReporte: true,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                        dataRep: resp[0],
                        datosEst: resp[1]
                    }, () => {
                        /* this.props.updateList(); */
                    })
                })
            })
        }

        let Aceptar = (id) => () => {
            switch(this.props.tipo){
                case "Constancia de Culminación de Estudios (Simple)":
                    switch(true){
                        case(text1 === ""):
                            toast.error("Debes ingresar el Número",{autoClose: 4000});
                        break;
                        case(text2 === ""):
                            toast.error("Debes ingresar el Numero del Folio",{autoClose: 4000});
                        break;
                        case(text3 === ""):
                            toast.error("Debes ingresar el Tomo",{autoClose: 4000});
                        break;
                        case(textFecha === ""):
                            toast.error("Debes ingresar la Fecha",{autoClose: 4000});
                        break;
                        default:
                            AceptOk(id)
                        break;
                    }
                break;
                case "Constancia de Culminación de Estudios (Certificada)":
                    switch(true){
                        case(text1 === ""):
                            toast.error("Debes ingresar el Número",{autoClose: 4000});
                        break;
                        case(text2 === ""):
                            toast.error("Debes ingresar el Numero del Folio",{autoClose: 4000});
                        break;
                        case(text3 === ""):
                            toast.error("Debes ingresar el Tomo",{autoClose: 4000});
                        break;
                        case(textFecha === ""):
                            toast.error("Debes ingresar la Fecha",{autoClose: 4000});
                        break;
                        default:
                            AceptOk(id)
                        break;
                    }
                break;
                default:
                    AceptOk(id)
                break;
            }
        }

        let contenido = () => {
            switch(this.props.tipo){
                case "Constancia de Culminación de Estudios (Simple)": return (
                    <React.Fragment>
                        <div className="text-danger" style = {{fontSize: 12, marginBottom:10}}><strong>Esta Constancia requiere información adicional. Por favor completa los siguientes campos:</strong></div>
                        <Row>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Número:</div>
                                <input type = "text" value = {text1} onChange = {this.cambiaValor("text1")} className = "form-control" placeholder = "N°"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Folio:</div>
                                <input type = "text" value = {text2} onChange = {this.cambiaValor("text2")} className = "form-control" placeholder = "Folio"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Tomo:</div>
                                <input type = "text" value = {text3} onChange = {this.cambiaValor("text3")} className = "form-control" placeholder = "Tomo"/>
                            </Col>
                            <Col md = {6}>
                                <div style = {{fontSize: 10}}>Fecha:</div>
                                <DatePicker
                                    clearIcon= {<i className="fa fa-times"></i>}
                                    calendarIcon= {<i className="fa fa-calendar"></i>}
                                    className="form-control"
                                    onChange={this.cambiaFecha}
                                    value={textFecha}
                                />
                            </Col>
                        </Row>
                        <div className="custom-mt-10" style = {{fontSize: 12}}>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                        <Switch height={12} onChange={
                            () => { this.setState({ check: !this.state.check }) }
                        } width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
                    </React.Fragment>
                )
                case "Constancia de Culminación de Estudios (Certificada)": return (
                    <React.Fragment>
                        <div className="text-danger" style = {{fontSize: 12, marginBottom:10}}><strong>Esta Certificación requiere información adicional. Por favor completa los siguientes campos:</strong></div>
                        <Row>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Número:</div>
                                <input type = "text" value = {text1} onChange = {this.cambiaValor("text1")} className = "form-control" placeholder = "N°"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Folio:</div>
                                <input type = "text" value = {text2} onChange = {this.cambiaValor("text2")} className = "form-control" placeholder = "Folio"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Tomo:</div>
                                <input type = "text" value = {text3} onChange = {this.cambiaValor("text3")} className = "form-control" placeholder = "Tomo"/>
                            </Col>
                            <Col md = {6}>
                                <div style = {{fontSize: 10}}>Fecha:</div>
                                <DatePicker
                                    clearIcon= {<i className="fa fa-times"></i>}
                                    calendarIcon= {<i className="fa fa-calendar"></i>}
                                    className="form-control"
                                    onChange={this.cambiaFecha}
                                    value={textFecha}
                                />
                            </Col>
                        </Row>
                        <div className="custom-mt-10" style = {{fontSize: 12}}>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                        <Switch height={12} onChange={
                            () => { this.setState({ check: !this.state.check }) }
                        } width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
                    </React.Fragment>
                )
                default: return (
                    <React.Fragment>
                        <div>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                        <Switch height={12} onChange={
                            () => { this.setState({ check: !this.state.check }) }
                        } width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
                    </React.Fragment>
                )
            }
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = {large}
                isopen =  {openOk}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = { Aceptar(this.props.datos.id) }
                funcion2 = { () => {this.setState({openOk: false}) }}
            />
        );
    }
    
    modalReporte = () => {
        const { openReporte, dataRep, datosEst, text1, text2, text3, textFecha } = this.state;

        if (openReporte === false) return null;

        let { datos } = this.props;

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let contenidoModal = () => {
            switch(this.props.tipo){
                case "Carta de Egreso": return (
                    <CartaEgreso
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                case "Carga Horaria": return (
                    <CargaHoraria
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                case "Certificación Plan de Estudios (Pensum)": return (
                    <Pensum
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                case "Constancia de Modalidad de Estudio (Simple)": return (
                    <ModEstudioSimple
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                case "Constancia de Modalidad de Estudio (Certificada)": return (
                    <ModEstudioCert
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                case "Constancia de Culminación de Estudios (Simple)": return (
                    <CulminacionEstS
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                        numero = {text1}
                        folio = {text2}
                        tomo = {text3}
                        fechaDoc = {textFecha}
                    />
                )
                case "Constancia de Culminación de Estudios (Certificada)": return (
                    <CulminacionEstCertS
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                        numero = {text1}
                        folio = {text2}
                        tomo = {text3}
                        fechaDoc = {textFecha}
                    />
                )
                case "Constancia de Buena Conducta (Certificada)": return (
                    <ConsConductaCert
                        datos= {datosEst}
                        token = {dataRep.token}
                        fecha = {dataRep.fecha}
                    />
                )
                default: return null;
            }
        }

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo={`${this.props.tipo} de ${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}`}
                display= "block"
                cerrar = {() => {
                    this.setState({
                        openReporte:false
                    }, () => {
                        this.props.updateList();
                    })
                }}
            />
        )
    }

    render() {
        let { datos } = this.props;
        let { preloadCarrera } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let MenuContent = () => (
            <Popover bsSize="large" id="menuItems2">
                <div className="text-primary" onClick={this.openModal("openOk", "openCancel")} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-check"></i> Aprobar e Imprimir</div>
                <div className="text-danger" onClick={this.openModal("openCancel", "openOk")} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-times"></i> Cancelar Solicitud</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{`${datos.nacionalidad} ${datos.ci}`}</td>
                    <td style={styles}>{nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</td>
                    <td align="center" style={styles}><i className={preloadCarrera.icon}></i> {preloadCarrera.text}</td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={MenuContent()}>
                            <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalCancel()}
                {this.modalOk()}
                {this.modalReporte()}
            </React.Fragment>
        );
    }
}
 
export default SolPendientes;


// WEBPACK FOOTER //
// ./src/views/Reportes/SolicitudesContent/SolPendientes.jsx